import { render, staticRenderFns } from "./OwalEventBannerTimeline.vue?vue&type=template&id=f0e91c2e&scoped=true"
import script from "./OwalEventBannerTimeline.vue?vue&type=script&lang=js"
export * from "./OwalEventBannerTimeline.vue?vue&type=script&lang=js"
import style0 from "./OwalEventBannerTimeline.vue?vue&type=style&index=0&id=f0e91c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e91c2e",
  null
  
)

export default component.exports